import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="local-time" on a <time datetime> element.
//
// The server renders tip-off in the arena's time zone. When the visitor is
// somewhere else, rewrite it in their zone and keep the arena time as a title.
// When the zones match, the server's text is left alone.
export default class LocalTimeController extends Controller<HTMLTimeElement> {
  static targets = ["long", "short"];
  static values = { zone: String };

  declare readonly hasLongTarget: boolean;
  declare readonly longTarget: HTMLElement;
  declare readonly hasShortTarget: boolean;
  declare readonly shortTarget: HTMLElement;
  declare readonly zoneValue: string;

  connect() {
    const visitorZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!visitorZone || visitorZone === this.zoneValue) return;

    const tipOff = new Date(this.element.dateTime);
    if (isNaN(tipOff.getTime())) return;

    // The server pads the hour with a space, so squash runs of whitespace.
    const arenaTime = this.hasLongTarget ? this.longTarget.textContent?.replace(/\s+/g, " ").trim() : undefined;

    if (this.hasLongTarget) {
      this.longTarget.textContent = format(tipOff, {
        weekday: "long",
        month: "long",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        timeZoneName: "short",
      });
    }
    if (this.hasShortTarget) {
      this.shortTarget.textContent = format(tipOff, {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
      });
    }
    if (arenaTime) this.element.title = `${arenaTime} at the arena`;
  }
}

function format(date: Date, options: Intl.DateTimeFormatOptions): string {
  return new Intl.DateTimeFormat(undefined, options).format(date);
}
